"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAvatar = void 0;
const react_1 = __importDefault(require("react"));
const DefaultAvatar = ({ displayName, size = "medium", className = "", }) => {
    let sizeClasses;
    switch (size) {
        case "extra-small":
            sizeClasses = "lg:w-8 lg:h-8 lg:text-md ";
            break;
        case "small":
            sizeClasses = "lg:w-10 lg:h-10 lg:text-md";
            break;
        case "medium":
            sizeClasses = "lg:w-12 lg:h-12 lg:text-xl ";
            break;
        case "large":
            sizeClasses = "lg:w-20 lg:h-20 lg:text-3xl ";
            break;
        case "full":
            sizeClasses = "xs:w-full xs:h-full xs:text-xl";
            break;
    }
    return (react_1.default.createElement("figure", { className: "flex justify-center items-center rounded-full text-white w-6 h-6 text-sm relative " +
            sizeClasses +
            className },
        react_1.default.createElement(Background, { className: "absolute top-0 left-0 w-6 h-6 " + sizeClasses }),
        react_1.default.createElement("p", { style: { zIndex: 0 } }, displayName && displayName[0].toUpperCase())));
};
exports.DefaultAvatar = DefaultAvatar;
const Background = ({ className }) => (react_1.default.createElement("svg", { width: "75", height: "75", viewBox: "0 0 75 75", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
    react_1.default.createElement("mask", { id: "mask0", x: "0", y: "0", "mask-type": "alpha" },
        react_1.default.createElement("circle", { cx: "37.5", cy: "37.5", r: "37.5", fill: "#0042DA" })),
    react_1.default.createElement("g", { mask: "url(#mask0)" },
        react_1.default.createElement("rect", { x: "-30", y: "-43", width: "131", height: "154", fill: "#0042DA" }),
        react_1.default.createElement("rect", { x: "2.50413", y: "120.333", width: "81.5597", height: "86.4577", rx: "2.5", transform: "rotate(-52.6423 2.50413 120.333)", stroke: "#FED23D", strokeWidth: "5" }),
        react_1.default.createElement("circle", { cx: "76.5", cy: "-1.5", r: "29", stroke: "#FF8E20", strokeWidth: "5" }),
        react_1.default.createElement("path", { d: "M-49.8224 22L-15.5 -40.7879L18.8224 22H-49.8224Z", stroke: "#F7F8FF", strokeWidth: "5" }))));
//# sourceMappingURL=DefaultAvatar.js.map